export default __webpack_public_path__ + "static/media/image3.c9d8e5a1.png";